import classnames from 'classnames';
import useResizeObserver from 'hooks/use-resize-observer';
import React, { useMemo, useState } from 'react';
import styles from './styles.scss';
import { toast } from 'components/dialogs';
import { history } from '@store/history';
import generatePath from '@utils/generatePath';
import { SUCCESS_PAGE} from 'constants/url';
import { fetchUpdateStudent } from '@services/landing';
import { qsParse } from '@utils/url-utils';

type IProps = {
	regId?: string;
	value?: string;
	title?: string;
	name?: string;
	mark?: string;
}

export default function(props: IProps){
	const [selectItem, setSelectItem] = useState<any>();
	const [currentIndex, setCurrentIndex ] = useState(1);
	const { width } = useResizeObserver();
	const { regId, value, title, name, mark } = qsParse();
	const listAll = [
			{ title: "Better grades", id: 1 },
			{ title: "Exam preparation", id: 2 },
			{ title: "Help with homework", id: 3 },
			{ title: "Something else", id: 4 }];

	const renderItemIcon = useMemo(() => {
		return listAll?.map((item: { title: any; id: any }) => {
			const { title, id } = item;
			return (
				<div
				key={id}
				className={classnames(styles['ac-tutor-item'], styles[`${currentIndex === id ? 'active' : ''}`])}
				onClick={ () => {setSelectItem(item); setCurrentIndex(id) }}>
					<div className={styles['item-content']}>
						<h2>{title}</h2>
					</div>
				</div>
			);
		});
	}, [listAll]);

	if (selectItem) {
	}
	async function handleSubmit() {
		fetchUpdateStudent({
			regId: regId,
			firstName: name,
			weakSubjectCode: title,
			stuGradeCode: value,
			mark: `--Your message: ${mark}.  --Why is tutoring required？Because:${name}用户的内容${selectItem.title}`,
			languages: ["en"]
		}).then((res) => {
				console.log(res, 'res');
			}).catch((err) => {
				if (err.code == '0') {
					history.push({
						pathname: generatePath(SUCCESS_PAGE)
					});
				}

		});

	}
	return (
		<section className={styles['ac-section']}>
			{ width<1200 ? <div className={styles['ac-tutor']}>
				<div className={styles['ac-header']}>
					<div className={styles['inner']}>
						<div className={styles['logo_container']}>
							<a href="/">
								<img loading="lazy" className={styles['logo_icon']} src="https://web-data.zmlearn.com/image/8UhXesmBNq64iYXEsKpb1N/logo_nav%402x.png" alt="air-class"/>
							</a>
						</div>
					</div>
				</div>
				<div className={styles['ac-tutor-container']}>
					<h1>Why is tutoring required?</h1>
					<div className={styles['steps']}>
						<div className={styles['step1']}></div>
						<div className={styles['step2']}></div>
						<div className={styles['step3']}></div>
						<div className={styles['step4']}></div>
					</div>
					<div className={styles['ac-tutor-list']}>{renderItemIcon}</div>
					<button className={styles['submit-button']} onClick={handleSubmit}>CONTINUE</button>
				</div>
			</div> : <div className={styles['eeo-schoolAuthReg']}>
				<div className={styles['leftBox']}>
					<div className={styles['formBox']}>
						<div className={styles['eeo-formBoxLogin']}>
							<div className={styles['ac-classes-container']}>
								<h1>Which subject do you need help?</h1>
								<div className={styles['steps']}>
									<div className={styles['step1']}></div>
									<div className={styles['step2']}></div>
								</div>
								<div className={styles['ac-tutor-list']}>{renderItemIcon}</div>
								<button className={styles['submit-button']} onClick={handleSubmit}>CONTINUE</button>
							</div>
						</div>
					</div>
					<div className={styles['rightImg3']}></div>
					<div className={styles['header']}>
						<div className={styles['inner']}>
							<div className={styles['logo_container']}>
								<a href="/">
									<img loading="lazy" className={styles['logo_icon']} src="https://web-data.zmlearn.com/image/8UhXesmBNq64iYXEsKpb1N/logo_nav%402x.png" alt="air-class"/>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div> }
		</section>
	);
}

